import { render, staticRenderFns } from "./language-switcher.vue?vue&type=template&id=ef59b688"
import script from "./language-switcher.vue?vue&type=script&lang=ts"
export * from "./language-switcher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports